import {getCurrentAuthor, getCurrentCategory, getGtmAuthorAttributeValue, getGtmGridCardAttributeValue, getRelatedMediaType, getSvg} from "./helpers";
import {MediaAuthor, MediaPreview, PodcastLinks, RelatedMediaGridViewModel, RelatedMediaItem, TopicType} from "./types";
import {initializePodcastButtons, initializeShareButtons, renderPodcastButtons} from './podcast-card-icons';
import {playIcon, podcastIcon, shareIcon} from './icons';

/**
 * Draws the related media item based on data obtained from the endpoint response.
 * Needs the data as well as the appropriate grid to be drawn.
 * @param {any} relatedMediaItem
 * @param {any} data
 */
export const drawRelatedMedia = (relatedMediaItem: RelatedMediaItem, data: RelatedMediaGridViewModel) => {
    if (!data) return console.error("There is no data to render!");
    if (!relatedMediaItem) return console.error("There is no relatedMediaItem to render!");

    //now that we got the data, lets see if there is more pages and then increment the next page.
    if (data.Result.HasMoreItems) {
        window.veRelatedMedia.relatedMediaItems[relatedMediaItem.id].nextPage++;
        $(relatedMediaItem.element).find(".view-more").show();
    } else {
        $(relatedMediaItem.element).find(".view-more").hide();
    }

    var mkGrid = ""; //The markup for the entire grid component to be drawn, made of multiple insights items.
    var unformattedMessage = "";
    var formattedMessage = "";

    if (data.Result.GridCardDetails.length > 0) {
        data.Result.GridCardDetails.forEach((e, i) => {
            mkGrid += renderItem(e, relatedMediaItem.template ?? "insights-grid")
        })
    }
    else {
        const currentCategory = $("#InsightsDropdown .dropdown__label").text().trim();
        const currentMediaType = $("#InsightsTypeDropdown .dropdown__label").text().trim();
        var message = "";
        if (currentCategory && currentCategory != window.veDictionary.allInsights && currentMediaType && currentMediaType != window.veDictionary.allFormats) {
            unformattedMessage = window.veDictionary.noCategoriesVisit;
            formattedMessage = unformattedMessage.replace('{0}', currentCategory).replace('{1}', currentMediaType.toLowerCase()).replace('{2}', currentMediaType.toLowerCase());
            //message += `Sorry, there are no ${currentCategory} ${currentMediaType.toLowerCase()} at this time. Come back and visit for future ${currentMediaType.toLowerCase()}.`;
            message += formattedMessage;
        }
        else if (currentCategory && currentCategory != window.veDictionary.allInsights) {
            unformattedMessage = window.veDictionary.noCategoriesAtThisTime;
            formattedMessage.replace('{0}', currentCategory);
            //message += `Sorry, there are no ${currentCategoy} insights at this time.`;
            message += formattedMessage;
        }
        else {
            message += window.veDictionary.noCategories;
        }
        mkGrid += `<div class="text-center w-100"><p>${message}</p></div>`;
    }
    //iterate and render the elems


    //Draw the grid on the component and enable the view more button.
    $(relatedMediaItem.element).find(".draw-area").append(mkGrid);
    $(relatedMediaItem.element).find(".view-more .btn-primary").attr("disabled", null);

    window.veRelatedMedia.debug ? console.timeEnd("Render Items for Related Media-" + relatedMediaItem.id) : false;

    if (relatedMediaItem.template === 'podcast-list') {
        initializeShareButtons();
        initializePodcastButtons()
    }
}

const renderTags = (item: MediaPreview) => {
  if (!item.TopicalTags) return '';
  return item.TopicalTags.map(tag => {
      const url = new URL(tag.LinkUrl.Uri, window.location.origin);
      const topicValue = url.searchParams.get('tag');
      
      return `
          <a href="${tag.LinkUrl.OriginalString}" class="tag ${tag.TopicType === TopicType.Fund ? "related-fund" : ""}">
              <span>#${tag.LinkText}</span>
          </a>
      `;
  }).join('');
}

const renderListenText = (item: MediaPreview) => {
  if (!item.Time) return '';

  return `
        <div class="podcast-card__listen-time">
            <p>
            ${playIcon()}
            <span>Listen | ${item.Time}</span>
            </p>
        </div>
  `
}

const hasAnyLink = (links: PodcastLinks | undefined | null): boolean => {
  if (!links) return false;
  return Object.values(links).some(value => value !== null);
};

/**
 * Generates the markup for a signle related media media item, based on a template
 * @param {any} item
 * @param {any} template
 */
export const renderItem = (item: MediaPreview, template: string) => {
    const targetAttr = isVanEckUrl(item.MediaLink) ? '' : ' target="_blank"';
   
    var mkimage = item.PostSmallImage ?
        `<div class="position-relative"><a data-ve-gtm="item-image" class="grid-card__image-link" data-image="image" href="${item.MediaLink}" ${targetAttr}>
                                    <div class="grid-card__image-container mb-3 no-print">
                                      <div class="image grid-card__image" style="background-image:url(${item.PostSmallImage});padding-bottom:56.25%">
                                        <img alt="${item.Title}" class="image__img" src="${item.PostSmallImage}"></div>
                                    </div>
                                    <div class="grid-card__image-icon">${getSvg(item.Type)}</div>
                                  </a></div>`
        : "";

    var description = (item.Details != null && item.Details != "") ? item.Details : (item.Description != null && item.Description != "") ? item.Description : item.DescriptionString ?? "";
    var mksummary = item.PostSmallImage ? "" : `<div data-ve-gtm="item-abstract" class="grid-card__body">
                                 ${description}
                                </div>`;

    var rnAuthors = (authors: MediaAuthor[]) => {
        var mkAuthors = "";

        authors.forEach(e => {
            const hasauthorLink = () => e.Url != null && e.Url != "" && !getCurrentAuthor();
            var aOpen = hasauthorLink() ? `<a data-ve-gtm="${getGtmAuthorAttributeValue(item.Type)}" class="grid-card__label-link" href="${e.Url}">` : `<div class="grid-card__label-link">`;
            var aClose = hasauthorLink() ? `</a>` : "</div>";
            //var aOpen = `<div data-ve-gtm="${window.veRelatedMedia.getGtmAuthorAttributeValue(item.Type)}" class="grid-card__label-link">`;
            //var aClose = "</div>";
            mkAuthors += `<div class="grid-card__author">${aOpen}<span class="grid-card__label-title text-util-md">${e.Name}</span><span class="grid-card__label-title text-util-md">${e.Title != null ? e.Title : ""}</span>${aClose}</div>`
        });
        return mkAuthors;
    }

    /*var publishedDate = convCSDate(item.PublishDate)*/

    var mkcategory = item.Category ? `<span data-ve-gtm="item-category" class="text-util-md">${item.Category} ${getRelatedMediaType(item.Type)}</span>` : "";
    mkcategory = item.CategoryUrl != null && item.CategoryUrl != "" && !getCurrentCategory() ? `<a data-ve-gtm="item-category" class="grid-card__eyebrow-link" href="${item.CategoryUrl}">${mkcategory}</a>` : mkcategory;

    var mkCategory = item.Category ? `<div class="grid-card__eyebrow">${mkcategory}</div>` : "";
    var badge = item.Badge ? `<span class="grid-card__badge badge mb-2">${item.Badge} CE Credit</span>` : "";
    var liveOn = item.IsLiveWebinar
        ? '<span class="grid-card__badge badge mb-2">LIVE</span>'
        : item.IsUpcomingWebinar
            ? '<span class="grid-card__badge badge mb-2">Live On</span>'
            : "";

/*    var rnReadTime = (insightsType: string, readTime: string) => {
        if (readTime == null || typeof insightsType != "string") return "";
        switch (insightsType.toLowerCase()) {
            case "blog":
                return `<p class="text-util-md mb-2 grid-card__read-time">${item.FormattedTime}</p>`;
            case "video":
                return `<p class="text-util-md mb-2 grid-card__read-time">${item.FormattedTime}</p>`;
            case "podcast":
                return `<p class="text-util-md mb-2 grid-card__read-time">${item.FormattedTime}</p>`
            default:
                return "";
        }
    }*/

    var rnReadTime = item.FormattedTime ? `<p class="text-util-md mb-2 grid-card__read-time">${item.FormattedTime}</p>` : "";
    var rnDate = item.FormattedPublishDate ? `<p data-ve-gtm="item-date" class="text-util-md mb-2" > ${liveOn} ${item.FormattedPublishDate } </p>` : "";

    switch (template) {

        /***
         *  In future if other templates are required for the grid, we can add them here as another case.
         **/
        case "podcast-list":
            return `<div class="podcast-card col-md-6 col-lg-3"">
                        <div data-ve-gtm="${getGtmGridCardAttributeValue(item.Type)}" class="grid-card" data-src="${item.PlayerLink ? item.PlayerLink : ''}">
                          <div class="podcast-card__image">
                              <div class="position-relative">
                                  <div class="grid-card__image-container grid-card__image-link mb-3 no-print">
                                    <div class="image grid-card__image" style="background-image:url(${item.PostSmallImage});padding-bottom:56.25%">
                                      <img alt="${item.Title}" class="image__img" src="${item.PostSmallImage}"></div>
                                  </div>
                                  <div class="grid-card__image-icon">${getSvg(item.Type)}</div>
                              </div>
                          </div>
                          <div class="podcast-card__content">
                              <div class="podcast-card__header" data-ve-gtm="item-title" class="grid-card__title-link">
                                  <h3 class="mb-0">${item.Title}</h3>
                              </div>
                              <div class="podcast-card__description">
                                  ${description}
                              </div>
                              <div class="podcast-card__date">
                                  <p>${item.FormattedPublishDate.length ? item.FormattedPublishDate : ''}</p>
                              </div>
                              ${renderListenText(item)}
                              <div class="podcast-card__bottom">
                                <div class="podcast-card__tags">
                                    ${renderTags(item)}
                                </div>
                                <div class="podcast-card__icons">
                                  <div class="share-icon-wrapper" data-url="${item.MediaLink}">
                                      <div class="share-icon">
                                          ${shareIcon()}
                                          <span class="tooltip">Share</span>
                                      </div>
                                  </div>
                                  ${hasAnyLink(item.ExternalLinks) ? `
                                      <div class="podcast-button-wrapper">
                                          <div class="podcast-icon">
                                              ${podcastIcon()}
                                          </div>
                                          ${renderPodcastButtons(item.ExternalLinks)}
                                      </div>
                                  ` : ''}
                                </div>
                              </div>
                          </div>
                        </div>
                    </div>`;
        case "landing-grid":
            return `<div class="insights-grid__item col-md-6 col-lg-3">
                              <div data-ve-gtm="${getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}"${targetAttr}>
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${item.Info ?? `${(item.Authors && rnAuthors(item.Authors)) ?? ""}`}
                                ${rnDate}
                                ${rnReadTime}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
        case "insights-grid":
        default:
            return `<div class="insights-grid__item col-md-6 col-lg-4">
                              <div data-ve-gtm="${getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}"${targetAttr}>
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${item.Info ?? `${(item.Authors && rnAuthors(item.Authors)) ?? ""}`}
                                ${rnDate}
                                ${rnReadTime}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
    }
}

export const renderPagination = (relatedMediaItem: RelatedMediaItem, data: RelatedMediaGridViewModel) => {
    if (!data) return console.error("There is no data to render!");
    if (!relatedMediaItem) return console.error("There is no relatedMediaItem to render!");

    const pageNumber = data.Result.PageNumber + 1;
    const totalPages = data.Result.PageTotalCount;
    let $paginationContainer = $(relatedMediaItem.element).find("#insights-paginator");
    if (totalPages > 0) {
        $paginationContainer.removeClass("d-none").addClass("d-block")
    } else {
        $paginationContainer.removeClass("d-block").addClass("d-none")
    };

    let markup = "";
    if (data.Result.PageNumber > 0) {
        markup += `<button class="btn-pagination" aria-label="${data.Result.PageNumber - 1}" data-pageid="${data.Result.PageNumber - 1}"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" fill="#323232"/>
<g clip-path="url(#clip0_168_20283)">
<path d="M19.8216 24.9864L25.4181 30.5989L23.995 31.99L16 23.995L23.995 16L25.4181 17.3911L19.8216 22.9876H31.99V24.9864H19.8216Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_168_20283">
<rect width="15.99" height="15.99" fill="white" transform="matrix(1 0 0 -1 16 31.99)"/>
</clipPath>
</defs>
</svg>
</button>`
    } else {
        markup += `<button aria-label="1"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" fill="#CCCCCC"/>
<g clip-path="url(#clip0_161_20245)">
<path d="M19.8216 24.9864L25.4181 30.5989L23.995 31.99L16 23.995L23.995 16L25.4181 17.3911L19.8216 22.9876H31.99V24.9864H19.8216Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_161_20245">
<rect width="15.99" height="15.99" fill="white" transform="matrix(1 0 0 -1 16 31.99)"/>
</clipPath>
</defs>
</svg>
</button>`
    }

    markup += getPaginationMarkup(relatedMediaItem, pageNumber, totalPages);

    if (data.Result.PageNumber < data.Result.PageTotalCount - 1) {
        markup += `<button class="btn-pagination" aria-label="${data.Result.PageNumber + 1}" data-pageid="${data.Result.PageNumber + 1}"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" fill="#323232"/>
<g clip-path="url(#clip0_161_20258)">
<path d="M28.1684 24.9864H16V22.9876H28.1684L22.5719 17.3911L23.995 16L31.99 23.995L23.995 31.99L22.5719 30.5989L28.1684 24.9864Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_161_20258">
<rect width="15.99" height="15.99" fill="white" transform="matrix(1 0 0 -1 16 31.99)"/>
</clipPath>
</defs>
</svg>
</div>`
    } else {
        markup += `<button><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" fill="#CCCCCC"/>
<g clip-path="url(#clip0_161_20258)">
<path d="M28.1684 24.9864H16V22.9876H28.1684L22.5719 17.3911L23.995 16L31.99 23.995L23.995 31.99L22.5719 30.5989L28.1684 24.9864Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_161_20258">
<rect width="15.99" height="15.99" fill="white" transform="matrix(1 0 0 -1 16 31.99)"/>
</clipPath>
</defs>
</svg></div>`
    }
    $paginationContainer.find(".ve-pagination").html(markup)
}

export const getPaginationMarkup = (relatedMediaItem: RelatedMediaItem, pageNumber: number, totalPages: number) => {
    return `<span class="pagination-container">
    <label class="sr-only" for="current-page-number-id">Current Page number: ${pageNumber}</label>
    <input id="current-page-number-id" type="number" class="page-input" max="${totalPages}" value="${pageNumber}" /> / <b>${totalPages}</b></span>`
}

export const renderLoader = (relatedMediaItem: RelatedMediaItem) => {
    $(relatedMediaItem.element).find(".draw-area").html(
    `<div class="insights-loader">
        <div class="component-loading" style="width: 100%"></div>
    </div>`);
}

export const renderFeaturedPodcast = (item: MediaPreview) => {
  const description = (item.Details != null && item.Details != "") ? item.Details : (item.Description != null && item.Description != "") ? item.Description : item.DescriptionString ?? "";
  
  return `
      <div>
            <div class="podcast-card featured-podcast">
                <div class="featured-podcast__heading">
                  <p>Featured Podcast</p>
                </div>
                <div data-ve-gtm="${getGtmGridCardAttributeValue(item.Type)}" class="grid-card" data-src="${item.PlayerLink ? item.PlayerLink : ''}">
                  <div class="podcast-card__content">
                      <div class="podcast-card__header">
                        <p class="grid-card__category">${item.Category}</p>
                      </div>
                      <div class="podcast-card__header" data-ve-gtm="item-title" class="grid-card__title-link">
                          <h3 class="mb-0">${item.Title}</h3>
                      </div>
                      <div class="podcast-card__description">
                          ${description}
                      </div>
                      <div class="podcast-card__date">
                          <p>${item.FormattedPublishDate.length ? item.FormattedPublishDate : ''}</p>
                      </div>
                      ${renderListenText(item)}
                      <div class="podcast-card__bottom">
                        <div class="podcast-card__tags">
                            ${renderTags(item)}
                        </div>
                        <div class="podcast-card__icons">
                          <div class="share-icon-wrapper" data-url="${item.MediaLink}">
                              <div class="share-icon">
                                  ${shareIcon()}
                                  <span class="tooltip">Share</span>
                              </div>
                          </div>
                          ${hasAnyLink(item.ExternalLinks) ? `
                              <div class="podcast-button-wrapper">
                                  <div class="podcast-icon">
                                      ${podcastIcon()}
                                  </div>
                                  ${renderPodcastButtons(item.ExternalLinks)}
                              </div>
                          ` : ''}
                        </div>
                      </div>
                  </div>
                  <div class="podcast-card__image">
                      <div class="position-relative">
                          <div class="grid-card__image-container grid-card__image-link mb-3 no-print">
                              <div class="image grid-card__image" style="background-image:url(${item.PostSmallImage});padding-bottom:56.25%">
                                  <img alt="${item.Title}" class="image__img" src="${item.PostSmallImage}">
                              </div>
                          </div>
                          <div class="grid-card__image-icon">${getSvg(item.Type)}</div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
  `;
}

export const isVanEckUrl = (urlString: string): boolean => {
  if (!urlString) {
        return false;
    };
    
    if (urlString.startsWith('/')) {
        return true;
    }
    
    if (urlString.startsWith('http://') || urlString.startsWith('https://')) {
        try {
            const url = new URL(urlString);
            return url.hostname.endsWith('vaneck.com');
        } catch (e) {
            return false;
        }
    }
    
    if (urlString.includes('vaneck.com')) {
        return true;
    }

    return false;
}